import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { AURORA_ANCHORS, AURORA_THEME } from "./theme";

// Aurora narrative section. The 5 PDF paragraphs of marketing copy framed inside
// a deep-space backdrop with two low-opacity radial blobs that suggest aurora wisps
// without the perf/brittleness of true mask-image transitions.

const PARAGRAPH_KEYS = ["p1", "p2", "p3", "p4", "p5"];

const AuroraStory = () => {
  const { t } = useTranslation();

  return (
    <section
      id={AURORA_ANCHORS.story}
      className="tw-relative tw-w-full tw-overflow-hidden tw-py-16 md:tw-py-24"
      style={{ background: AURORA_THEME.gradients.storyBackdrop }}
    >
      <div
        aria-hidden="true"
        className="tw-pointer-events-none tw-absolute tw-inset-0"
        style={{ background: AURORA_THEME.gradients.auroraWispLeft }}
      />
      <div
        aria-hidden="true"
        className="tw-pointer-events-none tw-absolute tw-inset-0"
        style={{ background: AURORA_THEME.gradients.auroraWispRight }}
      />

      <div className="tw-relative tw-mx-auto tw-max-w-3xl tw-space-y-5 tw-px-6 md:tw-px-8">
        {PARAGRAPH_KEYS.map((key, index) => (
          <motion.p
            key={key}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ delay: index * 0.08, duration: 0.5 }}
            className="tw-text-base tw-leading-relaxed md:tw-text-lg"
            style={{ color: AURORA_THEME.text.secondary }}
            dangerouslySetInnerHTML={{
              __html: t(`campaign.aurora.marketing_copy.${key}`),
            }}
          />
        ))}
      </div>
    </section>
  );
};

export default AuroraStory;
